import { sampleQueryKeys } from '@/config/queryKeys';
import { SampleDetailsPage } from '@/pages/Samples/components/SampleDetailsPage';
import { useOrgId } from '@/pages/Samples/helpers';
import type { SampleWithNamesPublic } from '@/types';
import { Text } from '@nautilusbio/nb-design-system/Text';
import { useQuery } from '@tanstack/react-query';
import { createLazyFileRoute } from '@tanstack/react-router';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const Route = createLazyFileRoute('/samples/$sampleId')({
  component: RouteComponent,
});

function RouteComponent() {
  const { sampleId } = Route.useParams();
  const orgId = useOrgId();
  const { t } = useTranslation('studies');

  // The loader seeds this cache entry from the AG Grid list cache.
  // TODO: when GET /orgs/{orgId}/samples/{sampleId} is available, replace the
  //       queryFn stub with getSample (src/services/samples.ts) and remove `enabled: false`.
  const { data: sample } = useQuery<SampleWithNamesPublic>({
    queryKey: sampleQueryKeys.detail(orgId ?? '', sampleId),
    queryFn: () => Promise.reject<SampleWithNamesPublic>(new Error('getSample endpoint not yet available')),
    enabled: false,
    staleTime: Number.POSITIVE_INFINITY,
  });

  if (!orgId || !sample) {
    return <Text as="span">{t('samples.details.notFound')}</Text>;
  }

  return <SampleDetailsPage sample={sample} orgId={orgId} />;
}
